import { render, staticRenderFns } from "./ListPackage.vue?vue&type=template&id=aa24174c&scoped=true&"
import script from "./ListPackage.vue?vue&type=script&lang=ts&"
export * from "./ListPackage.vue?vue&type=script&lang=ts&"
import style0 from "./ListPackage.vue?vue&type=style&index=0&id=aa24174c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa24174c",
  null
  
)

export default component.exports